<template>
  <div class="table-responsive container-bg">
    <table class="table table-hover">
      <thead>
        <tr>
          <th colspan="18" class="no-border">
            <div class="d-flex justify-content-start">
              <h3>Taken</h3>
            </div>
          </th>
        </tr>
        <tr>
          <!-- <th>Gemaakt bij</th> -->
          <th>
            <button
              @click="showFilterInputs = !showFilterInputs"
              class="rounded btn btn-md btn-primary"
            >
              Zoeken
            </button>
          </th>
          <th>Titel</th>
          <th></th>
        </tr>
        <tr v-if="showFilterInputs">
          <th colspan="2">
            <input
              v-model="filter_task_title"
              type="text"
              class="form-control"
            />
          </th>
          <th>
            <button
              @click="filterTask()"
              class="text-white rounded btn btn-md btn-dark"
            >
              Zoeken
            </button>
          </th>
        </tr>
      </thead>
      <thead></thead>
      <tbody>
        <tr v-if="loading">
          <td colspan="5" class="text-center">Aan het laden...</td>
        </tr>
        <tr v-for="(task, index) in tasks" :key="index">
          <th class="d-flex">
            <a
              data-toggle="modal"
              data-target="#eventModal"
              class="text-white btn btn-dark btn-sm small-size"
              @click="showTaskDetail(task)"
            >
              Open
            </a>
            <a
              data-toggle="modal"
              data-target="#editModal"
              class="ml-2 text-white btn btn-primary btn-sm small-size"
              @click="showTaskDetail(task)"
            >
              <i class="fas fa-pencil-alt"></i>
            </a>
          </th>

          <td>{{ task.title }}</td>
          <!-- <td>{{ task.created_at }}</td> -->
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <th colspan="18">
            <div class="d-flex justify-content-end" v-if="tasks.length > 0">
              <a
                v-if="current_page != prev_page"
                @click="getTasks('upcoming', prev_page)"
                class="mr-3"
                style="cursor: pointer"
              >
                <i class="fa fa-chevron-left"></i>
              </a>
              <a
                v-if="current_page != next_page"
                @click="getTasks('upcoming', next_page)"
                style="cursor: pointer"
              >
                <i class="fa fa-chevron-right"></i>
              </a>
            </div>
          </th>
        </tr>
      </tfoot>
    </table>

    <div
      class="modal fade"
      id="eventModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document" style="max-width: 1000px">
        <div class="modal-content committee-modal">
          <div class="modal-header" style="border-bottom: unset">
            <button
              type="button"
              class="close close-modal-button"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-header">
            <div class="modal-title w-100 d-flex justify-content-between h5">
              <div>{{ openedTask.title }}</div>
              <div>
                <span class="badge badge-success" v-if="openedTask.active == 1"
                  >Active</span
                >
                <span class="badge badge-danger" v-else>Not Active</span>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div class="row">
              <div
                class="col-12"
                v-if="openedTask.description && openedTask.description.length"
              >
                <h6>Omschrijving</h6>
                <p v-html="openedTask.description"></p>
              </div>

              <div class="col-lg-12">
                <button data-dismiss="modal" class="float-right mt-3 btn-dark">
                  Sluiten
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="editModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="editModal"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document" style="max-width: 500px">
        <div class="modal-content committee-modal">
          <div class="modal-header" style="border-bottom: unset">
            <button
              type="button"
              class="close close-modal-button"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-12">
                <form class="form" @submit.prevent="updateTask()">
                  <div class="form-group">
                    <label for="title">Title</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="openedTask.title"
                    />
                  </div>
                  <div class="form-group">
                    <label>Omschrijving</label>
                    <!-- <textarea class="form-control" v-model="openedTask.description"></textarea> -->
                    <editor
                      :id="'descriptionEditor_' + openedTask.id"
                      v-model="openedTask.description"
                      :init="{
                        height: 200,
                        menubar: false,
                        language: 'nl',
                        plugins: [
                          'advlist autolink lists link image charmap print preview anchor',
                          'searchreplace visualblocks code fullscreen',
                          'insertdatetime media table paste code help wordcount',
                        ],
                        toolbar:
                          'undo redo | formatselect | bold italic backcolor | \
                                        alignleft aligncenter alignright alignjustify | \
                                        bullist numlist outdent indent | removeformat | help',
                      }"
                    />
                  </div>
                  <button type="submit" class="btn btn-dark">
                    <span v-if="!loading">Bijwerken</span>
                    <span v-else>Bijwerken...</span>
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "index",
  components: {},
  computed: {},
  data() {
    return {
      showFilterInputs: false,
      tasks: [],
      search: {},
      active: 0,
      next_page: 1,
      prev_page: 1,
      loading: false,
      current_page: 1,
      isUpcoming: true,
      filter_task_title: null,
      openedTask: {},
    };
  },

  created() {
    this.getTasks();
  },
  methods: {
    updateTask() {
      this.loading = true;
      this.$store
        .dispatch("put", {
          endpoint: "/api/v1/tasks/" + this.openedTask.id,
          details: this.openedTask,
        })
        .then((resp) => {
          this.loading = false;
          console.log(resp);
          this.$store.dispatch("auth/makeNotification", {
            status: "Taken",
            statusText: "Taak succesvol bijgewerkt",
          });
        })
        .catch((error) => {
          console.log(error.request);
          this.loading = false;
        });
    },
    showTaskDetail(event) {
      this.openedTask = event;
    },
    filterTask() {
      if (this.filter_task_title.length < 1) {
        return false;
      }
      this.loading = true;
      this.$store
        .dispatch(
          "get",
          `/api/v1/task/filter?title=${this.filter_task_title}&page=${this.current_page}`
        )
        .then((data) => {
          this.loading = false;
          this.tasks = data.data.data;
        })
        .catch((error) => {
          this.loading = false;
          console.log(error);
        });
    },

    getTasks(period) {
      if (this.loading) return false;
      this.isUpcoming = period === "upcoming";
      //let filter = this.isUpcoming ? "upcoming" : "past";
      this.loading = true;
      this.active = this.isUpcoming ? 0 : 1;
      this.tasks = [];

      this.$store
        .dispatch("get", `/api/v1/tasks`)
        .then((data) => {
          //   console.log(data);
          //   let tasks;

          //   if (this.userHasPermissions(["Beheer Activiteiten"])) {
          //     tasks = data.data.data;
          //   } else {
          //     tasks = data.data.data.filter((item) => {
          //       return item.attendees.includes(this.$store.state.auth.user.id);
          //     });
          //   }

          //   this.tasks = [...tasks];
          this.tasks = [...data.data.data];
          if (data.data.next_page_url != null) {
            this.next_page = data.data.current_page + 1;
          }
          if (data.data.prev_page_url != null) {
            this.prev_page = data.data.current_page + -1;
          }
          this.current_page = data.data.current_page;
          this.loading = false;

          window.$(document).ready(function() {
            window
              .$(".table-responsive")
              .doubleScroll({ resetOnWindowResize: true });
          });
        })
        .catch((error) => {
          console.log(error.request);
          this.loading = false;
        });
    },
    toggle(id, val) {
      this.$store
        .dispatch("post", {
          endpoint: `/api/v1/tasks/cancel/${id}`,
          details: {
            canceled: val,
          },
        })
        .then(() => {
          const index = this.tasks.findIndex((item) => item.id === id);
          this.$set(this.tasks[index], "canceled", val);
        })
        .catch((error) => {
          console.log(error.request);
        });
    },
  },
  filters: {
    formatDate(value) {
      return moment(new Date(value)).format("DD-MM-YYYY HH:mm");
    },
  },
  watch: {
    // eslint-disable-next-line
    /* filter_start_date(value) {
      this.getTasks();
    }, */
    // eslint-disable-next-line
    /*  filter_end_date(value) {
      this.getTasks();
    }, */
    // eslint-disable-next-line
    /* filter_eventtype_title(value) {
      this.getTasks();
    }, */
    // eslint-disable-next-line
    /* filter_task_title(value) {
      this.getTasks();
    }, */
  },
};
</script>

<style scoped>
.small-size {
  font-size: 0.875rem !important;
}

.no-border {
  border-style: solid;
  border-width: 0px 0px 0px 0px;
}
</style>
